module.exports = __webpack_public_path__ + "img/icon_mnks.3640fc40.png";